import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { X, ArrowRight } from "lucide-react";
import { useSite, tx } from "@/lib/lang";
import { scrollToSection } from "@/hooks/useLenis";

export default function CtaPopup() {
  const { content, lang } = useSite();
  const cp = content.cta_popup || {};
  const kicker = tx(cp.kicker, lang) || (lang === "it" ? "Parliamone" : "Let's talk");
  const title = tx(cp.title, lang) || (lang === "it" ? "Hai un contratto energia in scadenza o una bolletta da capire?" : "An energy contract expiring or a bill you can't decode?");
  const text = tx(cp.text, lang) || (lang === "it" ? "La diagnostica iniziale è gratuita e senza impegno." : "The initial diagnostic is free, no strings attached.");
  const button = tx(cp.button, lang) || (lang === "it" ? "Contattaci" : "Contact us");
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (sessionStorage.getItem("cta-dismissed")) return;
    let shown = false;
    const trigger = () => {
      if (shown) return;
      shown = true;
      setShow(true);
    };
    const t = setTimeout(trigger, 12000);
    const onScroll = () => {
      const max = document.body.scrollHeight - window.innerHeight;
      if (max > 0 && window.scrollY / max >= 0.5) trigger();
    };
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => {
      clearTimeout(t);
      window.removeEventListener("scroll", onScroll);
    };
  }, []);

  const close = () => {
    setShow(false);
    sessionStorage.setItem("cta-dismissed", "1");
  };

  return (
    <AnimatePresence>
      {show && cp.attiva !== false && (
        <motion.div
          data-testid="cta-popup"
          initial={{ opacity: 0, y: 40, scale: 0.96 }}
          animate={{ opacity: 1, y: 0, scale: 1 }}
          exit={{ opacity: 0, y: 40, scale: 0.96 }}
          transition={{ duration: 0.45, ease: [0.22, 1, 0.36, 1] }}
          className="fixed bottom-4 inset-x-4 sm:inset-x-auto sm:right-6 sm:bottom-6 z-50 sm:w-[320px] bg-surface border border-royal/40 rounded-2xl p-6 shadow-2xl shadow-royal/20"
        >
          <button
            data-testid="cta-popup-close"
            onClick={close}
            className="absolute top-3 right-3 text-muted-foreground hover:text-ice transition-colors"
          >
            <X size={16} />
          </button>
          <span className="font-mono text-[10px] uppercase tracking-[0.2em] text-azure">
            {kicker}
          </span>
          <p className="mt-2 font-display text-lg font-semibold text-ice leading-snug">
            {title}
          </p>
          <p className="mt-2 text-xs text-muted-foreground leading-relaxed">
            {text}
          </p>
          <button
            data-testid="cta-popup-button"
            onClick={() => {
              close();
              scrollToSection("#contatti");
            }}
            className="mt-4 w-full inline-flex items-center justify-center gap-2 bg-royal hover:bg-azure hover:text-[#0B1424] transition-colors text-white text-sm font-semibold px-4 py-2.5 rounded-full"
          >
            {button}
            <ArrowRight size={15} />
          </button>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
